import axios from 'axios';

// Refresh the already-visible page range as one snapshot, keeping the server summary.
export async function readPaymentList(url, options, visiblePages = 1) {
  if (visiblePages <= 1) return axios.get(url, options);
  const deadline = Date.now() + 10000;
  let first;
  const rows = [];
  let loadedPages = 0;
  let hasNext = false;
  for (let page = 1; page <= visiblePages; page += 1) {
    if (document.hidden || Date.now() >= deadline) throw new Error('결과 조회를 중단했습니다.');
    const response = await axios.get(url, { ...options, params: { ...options.params, page }, timeout: Math.max(1, deadline - Date.now()) });
    if (response.data?.code !== 1000) throw new Error('결과를 조회하지 못했습니다.');
    first ||= response;
    const data = response.data.data;
    if (!Array.isArray(data?.rows)) return response;
    rows.push(...data.rows);
    loadedPages = page;
    hasNext = data.rows.length > 0 && Boolean(data.hasNext ?? (page * Number(data.limit || options.params.limit) < Number(data.total || 0)));
    if (!hasNext) break;
  }
  return { ...first, data: { ...first.data, data: { ...first.data.data, rows, hasNext, refreshedPages: loadedPages } } };
}
